import GiftCardsSection from '@sections/gift_cards';
import styles from './styles.module.scss';

export const GiftCardsLayout = () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.content_wrapper}>
                <div className={styles.content}>
                    <GiftCardsSection />
                </div>
            </div>
        </div>
    );
};
